import React from 'react';

import Button from '~/components/common/Button';

export default class toggler extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        {this.renderButton()}
        {this.renderDetails()}
      </div>
    );
  }

  renderButton() {
    if (this.props.toggled) {
      return null;
    }

    return (
      <Button
        mods={[!this.props.notAction && 'action', 'wide']}
        onClick={this.props.toggle}
        data-qa={this.props['data-qa']}
      >
        {this.props.button}
      </Button>
    );
  }

  renderDetails() {
    if (!this.props.toggled) {
      return null;
    }

    return this.props.content;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Toggler/index.js